import React, { useState } from 'react';
import { ClickAwayListener, TextField, Box } from '@material-ui/core';
import { OKRButton } from '../../Common/OKRButton';
import { CancelIcon, TickIcon } from '../../../config/svg/Action';
import './style.scss';

export const OkrTextEdit: React.FC<any> = (props) => {
	const { updateName, handleClickInputAway, okr, kr, goalType } = props;
	const keyData = goalType === 2 ? kr : okr;
	const description = goalType === 1 ? okr.objectiveName : keyData.keyDescription;
	const [textValue, setTextValue] = useState<String>(description);
	const inputRef = React.useRef<any>();

	const enterFocus = (e: any) => {
		e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length);
	};

	return (
		<ClickAwayListener onClickAway={(e) => handleClickInputAway(e, okr, goalType, keyData, textValue)}>
			<Box className='edit-okr-field'>
				<TextField
					rows={2}
					multiline
					value={textValue}
					autoFocus
					fullWidth
					onChange={(e) => setTextValue(e.target.value)}
					inputRef={inputRef}
					onFocus={(e) => enterFocus(e)}
				/>
				<Box className='edit-okr-actions'>
					<OKRButton
						className='edit-okr-cancel'
						icon={<CancelIcon />}
						handleClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							handleClickInputAway(e, okr, goalType, keyData, '', false);
						}}
					/>
					<OKRButton
						className='edit-okr-save'
						icon={<TickIcon />}
						handleClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							updateName(e, okr, goalType, keyData, textValue);
						}}
					/>
				</Box>
			</Box>
		</ClickAwayListener>
	);
};
